import React from "react";
import { Link } from "react-router-dom";

/**
 * 404 for /pay/* routes: the slug / code / UUID doesn't resolve.
 *
 * Distinct from the site-wide 404 so the message speaks to the
 * payer's situation ("this link is broken / expired / typo'd") not
 * the generic "page not found" — and because the /pay/* routes
 * live outside the Layout wrapper, the site 404 wouldn't be picked
 * up here anyway.
 */
export function NotFoundPage({ message }) {
  return (
    <div className="pay-not-found">
      <div style={{ fontSize: 48 }} aria-hidden="true">🔗</div>
      <h1 className="pay-not-found__title">Payment link not found</h1>
      <p className="pay-not-found__note">
        {message ||
          "This payment link doesn't exist, or the URL was typed incorrectly. Double-check the address and try again."}
      </p>
      <Link to="/" className="pay-receipt__link">
        Return to horuswallet.com
      </Link>
    </div>
  );
}
